export enum UbsObjectType {
  SINGLE_FAMILY_HOME = 'SINGLE_FAMILY_HOME',
  APARTMENT = 'APARTMENT',
}
